/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrgParent } from './OrgParent';
import {
    OrgParentFromJSON,
    OrgParentFromJSONTyped,
    OrgParentToJSON,
} from './OrgParent';

/**
 * 
 * @export
 * @interface Relationships
 */
export interface Relationships {
    /**
     * 
     * @type {OrgParent}
     * @memberof Relationships
     */
    directParent?: OrgParent;
    /**
     * 
     * @type {OrgParent}
     * @memberof Relationships
     */
    ultimateParent?: OrgParent;
}

/**
 * Check if a given object implements the Relationships interface.
 */
export function instanceOfRelationships(value: object): boolean {
    return true;
}

export function RelationshipsFromJSON(json: any): Relationships {
    return RelationshipsFromJSONTyped(json, false);
}

export function RelationshipsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Relationships {
    if (json == null) {
        return json;
    }
    return {
        
        'directParent': json['directParent'] == null ? undefined : OrgParentFromJSON(json['directParent']),
        'ultimateParent': json['ultimateParent'] == null ? undefined : OrgParentFromJSON(json['ultimateParent']),
    };
}

export function RelationshipsToJSON(value?: Relationships | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'directParent': OrgParentToJSON(value['directParent']),
        'ultimateParent': OrgParentToJSON(value['ultimateParent']),
    };
}

